import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ChangeLogState, ChangeLogStore } from './change-log.store';

@Injectable({ providedIn: 'root' })
export class ChangeLogQuery extends QueryEntity<ChangeLogState> {
  protected store: ChangeLogStore;

  constructor() {
    const store = inject(ChangeLogStore);

    super(store);

    this.store = store;
  }
}
